/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'

import * as Comm from "rpc/Comm/Comm"
import * as Login from "rpc/Login/Login"
export var ID_SCOPE_COMPANY = 0;
export var ID_SCOPE_PERM = -1;
export var ID_SCOPE_USER = -2;
export var PERM_ORDER_OPERATE = "order_operate";
export var PERM_ORDER_AUDIT_OPERATE = "order_audit_operate";
export var PERM_ORDER_AFTERSALE_OPERATE = "order_aftersale_operate";
export var PERM_ORDER_SIGNIN_OPERATE = "order_signin_operate";
export var PERM_ORDER_SCOPE_COMPANY = "order_scope_company";
export var PERM_ORDER_VIEW = "order_view";
export var PERM_ORDER_PAY_OPERATE = "order_pay_operate";
export var PERM_BUYER_ORDER_VIEW = "buyer_order_view";
export var PERM_BUYER_ORDER_OPERATE = "buyer_order_operate";
export var PERM_BUYER_ORDER_AUDIT_OPERATE = "buyer_order_audit_operate";
export var PERM_ECARD_VIEW = "ecard_view";
export var PERM_ECARD_OPERATE = "ecard_operate";
export var PERM_STAFF_VIEW = "staff_view";
export var PERM_STAFF_OPERATE = "staff_operate";
export var PERM_STAFF_PERM = "staff_perm";
export var PERM_SHOP_VIEW = "shop_view";
export var PERM_SHOP_OPERATE = "shop_operate";
export var PERM_BUYER_CUSTOM_VIEW = "buyer_custom_view";
export var PERM_BUYER_CUSTOM_OPERATE = "buyer_custom_operate";
export var PERM_BUYER_CUSTOM_MANAGE = "buyer_custom_manage";
export var PERM_SELLER_CUSTOM_VIEW = "seller_custom_view";
export var PERM_SELLER_CUSTOM_OPERATE = "seller_custom_operate";
export var PERM_SELLER_CUSTOM_MANAGE = "seller_custom_manage";
export var PERM_LOGISTICS_CUSTOM_VIEW = "logistics_custom_view";
export var PERM_LOGISTICS_CUSTOM_OPERATE = "logistics_custom_operate";
export var PERM_LOGISTICS_CUSTOM_MANAGE = "logistics_custom_manage";
export var PERM_CUSTOM_SCOPE_COMPANY = "custom_scope_company";
export var PERM_BUYER_CONTRACT_VIEW = "buyer_contract_view";
export var PERM_BUYER_CONTRACT_OPERATE = "buyer_contract_operate";
export var PERM_CUSTOM_COMPANY_CONFIG_VIEW = "custom_company_config_view";
export var PERM_CUSTOM_COMPANY_CONFIG_OPERATE = "custom_company_config_operate";
export var PERM_BUYER_VIEW = "buyer_view";
export var PERM_BUYER_OPERATE = "buyer_operate";
export var PERM_SKUGROUP_VIEW = "skuGroup_view";
export var PERM_SKUGROUP_OPERATE = "skuGroup_operate";
export var PERM_COMPANY_CONFIG_VIEW = "company_config_view";
export var PERM_COMPANY_CONFIG_OPERATE = "company_config_operate";
export var PERM_SKU_OPERATE = "sku_operate";
export var PERM_PLATFORM_COMPANY_OPERATE = "platform_company_operate";
export var PERM_FINANCE_BILL_VIEW = "finance_bill_view";
export var PERM_FINANCE_BILL_OPERATE = "finance_bill_operate";
export var PERM_FINORDER_RECEIPT_OPERATE = "finOrder_receipt_operate";
export var PERM_ACCOUNT_BILL_VIEW = "account_bill_view";
export var PERM_ACCOUNT_BILL_OPERATE = "account_bill_operate";
export var PERM_STORE_BILL_VIEW = "store_bill_view";
export var PERM_STORE_BILL_OPERATE = "store_bill_operate";
export var PERM_TRADE_STAT_VIEW = "trade_stat_view";
export var PERM_SALE_STAT_VIEW = "sale_stat_view";
export var PERM_THIRD_DATA_VIEW = "third_data_view";
export var PERM_SALEUSER_STAT_VIEW = "saleuser_stat_view";
export var PERM_COMPANY_REPORT_VIEW = "company_report_view";
export var PERM_DELIVERY_ORDER_VIEW = "delivery_order_view";
export var PERM_HR_COMMISSIONS_VIEW = "hr_commissions_view";
export var PERM_HR_COMMISSIONS_OPERATE = "hr_commissions_operate";
export var PERM_HR_COMMISSIONS_SCOPE_COMPANY = "hr_commissions_scope_company";
export var TABLE_SPEC_AppVerChangeLog = "AppVerChangeLog";
export var FORM_SPEC_AppVerChangeLog = "AppVerChangeLog";
export var ADDRESS_CODE_TYPE_PROVINCE = 1;
export var ADDRESS_CODE_TYPE_CITY = 2;
export var ADDRESS_CODE_TYPE_DISTRICT = 3;

export class AddressCode {
    constructor() {
        this.code = 0;  // 0 require
        this.title = "";  // 1 require
        this.type = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AddressCode.__json_class__ = 'MisComm.AddressCode'

export class AddressCodeQuery {
    constructor() {
        this.province = 0;  // 0 optional
        this.city = 0;  // 1 optional
        this.district = 0;  // 2 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

AddressCodeQuery.__json_class__ = 'MisComm.AddressCodeQuery'
export var CONTACT_TYPE_CONTACT = "contact";
export var CONTACT_TYPE_SHOP = "shop";
export var CONTACT_TYPE_STORE = "store";
export var CONTACT_TYPE_CUSTOM = "custom";

export class Contact {
    constructor() {
        this.contactUUID = "";  // 0 require
        this.userid = 0;  // 1 require
        this.name = "";  // 2 require
        this.phone = "";  // 3 require
        this.mobile = "";  // 4 require
        this.address = "";  // 5 require
        this.defaultBeginTime = 0;  // 6 require
        this.defaultEndTime = 0;  // 7 require
        this.isDefault = false;  // 8 require
        this.province = "";  // 9 require
        this.city = "";  // 10 require
        this.district = "";  // 11 require
        this.shopName = "";  // 12 require
        this.shopType = "";  // 13 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Contact.__json_class__ = 'MisComm.Contact'

export class SellerCompanyConfig {
    constructor() {
        this.orderCloseTime = null;  // 0 require
        this.notifyUserids = [];  // 1 require
        this.hideOriginPrice = false;  // 2 require
        this.mall_tabsType = "mix";  // 3 require
        this.showStock = false;  // 4 require
        this.showStockHint = false;  // 5 require
        this.showSoldCount = false;  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SellerCompanyConfig.__json_class__ = 'MisComm.SellerCompanyConfig'
export var STAT_PERIOD_DAY = "day";
export var STAT_PERIOD_WEEK = "week";
export var STAT_PERIOD_MONTH = "month";

export class OrderStatBar {
    constructor() {
        this.date = null;  // 0 require
        this.uvCount = 0;  // 1 require
        this.uOrderCount = 0;  // 2 require
        this.orderCount = 0;  // 3 require
        this.orderAmount = 0;  // 4 require
        this.uPayCount = 0;  // 5 require
        this.payOrderCount = 0;  // 6 require
        this.payAmount = 0;  // 7 require
        this.skuCount = 0.0;  // 8 require
        this.freeSkuCount = 0.0;  // 9 require
        this.grossProfit = 0;  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderStatBar.__json_class__ = 'MisComm.OrderStatBar'

export class PlatformCard {
    constructor() {
        this.cardid = 0;  // 0 require
        this.membership_number = "";  // 1 require
        this.wx_unionid = "";  // 2 require
        this.wx_openid = "";  // 3 require
        this.wx_cardid = "";  // 4 require
        this.points = -1;  // 5 require
        this.mobile = "";  // 6 require
        this.create_time = null;  // 7 require
        this.userid = 0;  // 8 require
        this.companyid = 0;  // 9 require
        this.experience = -1;  // 10 require
        this.consumedBalance = -1;  // 11 require
        this.consumedPoints = -1;  // 12 require
        this.balance = -1;  // 13 require
        this.riceCoin = 0;  // 14 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PlatformCard.__json_class__ = 'MisComm.PlatformCard'

export class CompanyCard {
    constructor() {
        this.cardid = 0;  // 0 require
        this.membership_number = "";  // 1 require
        this.wx_unionid = "";  // 2 require
        this.wx_openid = "";  // 3 require
        this.wx_cardid = "";  // 4 require
        this.points = -1;  // 5 require
        this.mobile = "";  // 6 require
        this.create_time = null;  // 7 require
        this.target_customCompanyid = 0;  // 8 require
        this.companyid = 0;  // 9 require
        this.experience = -1;  // 10 require
        this.consumedBalance = -1;  // 11 require
        this.consumedPoints = -1;  // 12 require
        this.balance = -1;  // 13 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyCard.__json_class__ = 'MisComm.CompanyCard'
export var BATCH_PAY_TYPE_ORDER = "order";
export var BATCH_PAY_TYPE_BILL = "bill";
export var PAY_CHANNEL_NETPAY = "netpay";
export var PAY_CHANNEL_YOYIPAY = "yoyipay";
export var PAY_TYPE_SCAN_QRCODE = "scan_qrcode";
export var PAY_TYPE_CALL_PAY = "call_pay";

export class PayInfoIn {
    constructor() {
        this.ids = [];  // 0 require
        this.idType = "";  // 1 require
        this.successUrl = "";  // 2 require
        this.payType = "";  // 3 require
        this.amount = 0;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PayInfoIn.__json_class__ = 'MisComm.PayInfoIn'

export class PayInfo {
    constructor() {
        this.payString = "";  // 0 require
        this.gateway = "";  // 1 require
        this.payChannel = "";  // 2 require
        this.outTradeid = "";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PayInfo.__json_class__ = 'MisComm.PayInfo'

export class PayStatus {
    constructor() {
        this.status = "";  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PayStatus.__json_class__ = 'MisComm.PayStatus'

export class DepositConfig {
    constructor() {
        this.balance = 0;  // 0 require
        this.riceCoin = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

DepositConfig.__json_class__ = 'MisComm.DepositConfig'

export class DepositIn {
    constructor() {
        this.amount = 0;  // 0 require
        this.buyer_companyid = 0;  // 1 require
        this.seller_companyid = 0;  // 2 require
        this.successUrl = "";  // 3 require
        this.payType = "";  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

DepositIn.__json_class__ = 'MisComm.DepositIn'

export class DepositPayInfo {
    constructor() {
        this.payInfo = new PayInfo();  // 0 require
        this.depositid = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

DepositPayInfo.__json_class__ = 'MisComm.DepositPayInfo'

export class DepositRecord {
    constructor() {
        this.depositid = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.amount = 0;  // 2 require
        this.tradeid = "";  // 3 require
        this.outTradeid = "";  // 4 require
        this.buyer_companyid = 0;  // 5 require
        this.seller_companyid = 0;  // 6 require
        this.transferCode = "";  // 7 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

DepositRecord.__json_class__ = 'MisComm.DepositRecord'

export class Company {
    constructor() {
        this.companyid = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.name = "";  // 2 require
        this.phone = "";  // 4 require
        this.mobile = "";  // 5 require
        this.email = "";  // 6 require
        this.logo = "";  // 7 require
        this.type = "";  // 8 require
        this.isBuyer = false;  // 9 require
        this.isSeller = false;  // 10 require
        this.desc = "";  // 11 require
        this.license = "";  // 12 require
        this.bankOpening = "";  // 13 require
        this.bankAccount = "";  // 14 require
        this.province = "";  // 15 require
        this.city = "";  // 16 require
        this.district = "";  // 17 require
        this.address = "";  // 18 require
        this.create_scope = "";  // 19 require
        this.create_companyid = 0;  // 20 require
        this.certifyStatus = "";  // 21 require
        this.create_time = null;  // 22 require
        this.refCount = 0;  // 23 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Company.__json_class__ = 'MisComm.Company'

export class CompanyBasic {
    constructor() {
        this.companyid = 0;  // 0 require
        this.userid = 0;  // 1 require
        this.name = "";  // 2 require
        this.phone = "";  // 4 require
        this.mobile = "";  // 5 require
        this.email = "";  // 6 require
        this.logo = "";  // 7 require
        this.type = "";  // 8 require
        this.isBuyer = false;  // 9 require
        this.isSeller = false;  // 10 require
        this.province = "";  // 11 require
        this.city = "";  // 12 require
        this.district = "";  // 13 require
        this.address = "";  // 14 require
        this.hasCreateMall = false;  // 15 require
        this.refCount = 0;  // 16 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyBasic.__json_class__ = 'MisComm.CompanyBasic'
export var SHOP_TYPE_SHOP = "shop";
export var SHOP_TYPE_STORE = "store";

export class Shop {
    constructor() {
        this.shopid = 0;  // 0 require
        this.code = "";  // 1 require
        this.userid = 0;  // 2 require
        this.companyid = 0;  // 3 require
        this.name = "";  // 4 require
        this.phone = "";  // 6 require
        this.mobile = "";  // 7 require
        this.email = "";  // 8 require
        this.desc = "";  // 9 require
        this.type = "";  // 10 require
        this.province = "";  // 11 require
        this.city = "";  // 12 require
        this.district = "";  // 13 require
        this.address = "";  // 14 require
        this.refCount = 0;  // 15 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Shop.__json_class__ = 'MisComm.Shop'

export class CustomShop {
    constructor() {
        this.shop = new Shop();  // 0 require
        this.isCreateCustom = false;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomShop.__json_class__ = 'MisComm.CustomShop'

export class ECardUsageRule {
    constructor() {
        this.cateids = [];  // 0 optional
        this.spuids = [];  // 1 optional
        this.skuids = [];  // 2 optional
        this.price = 0;  // 3 optional
        this.isOneTime = 0;  // 4 optional
        this.isOnlinePay = 1;  // 5 optional
        this.isFacecashPay = 0;  // 6 optional
        this.isAccountCreditPay = 0;  // 7 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

ECardUsageRule.__json_class__ = 'MisComm.ECardUsageRule'
export var STATUS_ORDER_ALL = "all";
export var STATUS_ORDER_WILL_PAY = "will_pay";
export var STATUS_ORDER_WILL_TRANSPORT = "will_transport";
export var STATUS_ORDER_WILL_RECEIVE = "will_receive";
export var STATUS_ORDER_RECEIVED = "received";
export var STATUS_ORDER_CANCELED = "canceled";
export var STATUS_ORDER_WILL_AUDIT = "will_audit";
export var STATUS_ORDER_RECEIVED_UNPAY = "received_unpay";
export var STATUS_ORDER_RECEIVED_PAYED = "received_payed";
export var STATUS_ORDER_AUDITED = "audited";
export var ORDER_CHARGE_TYPE_SELLER = "seller";
export var ORDER_CHARGE_TYPE_BUYER = "buyer";
export var AFTER_SALE_RETURN_REQUEST = "return_request";
export var AFTER_SALE_RETURNED = "returned";
export var AFTER_SALE_CHANGE_REQUEST = "change_request";
export var AFTER_SALE_CHANGED = "changed";
export var AFTER_SALE_ALL = "all";
export var PAY_METHOD_ALIPAY = "alipay";
export var PAY_METHOD_WEIXINPAY = "weixinpay";
export var PAY_METHOD_ACCOUNTCREDIT = "accountcredit";
export var PAY_METHOD_FACECASH = "facecash";
export var PAY_METHOD_TRANSFER = "transfer";
export var STATUS_PAY_IDLE = "idle";
export var STATUS_PAY_SUCCESS = "success";
export var STATUS_PAY_FAILED = "failed";
export var SIGNIN_METHOD_WEIXIN_QRCODE = "weixin_qrcode";
export var SIGNIN_METHOD_ALIPAY_QRCODE = "alipay_qrcode";
export var SIGNIN_METHOD_CASH = "cash";
export var SIGNIN_METHOD_SIGNIN = "signin";
export var DELIVERY_STATUS_WILL_SORT = "will_sort";
export var DELIVERY_STATUS_SORTED = "sorted";
export var DELIVERY_STATUS_DELIVERING = "delivering";
export var DELIVERY_STATUS_SIGNIN = "signin";
export var TYPE_ORDER_NORMAL = "normal";
export var TYPE_ORDER_CONTRACT = "contract";
export var TYPE_ORDER_POINT = "point";
export var TYPE_ORDER_CONTRACT_MIX = "contract_mix";
export var CHARGE_TYPE_BUYER = "buyer";
export var CHARGE_TYPE_SELLER = "seller";

export class OrderSku {
    constructor() {
        this.skuid = 0;  // 0 require
        this.count = 0;  // 1 require
        this.ss_name = "";  // 2 require
        this.ss_spec = "";  // 3 require
        this.ss_img = "";  // 4 require
        this.ss_price = 0;  // 5 require
        this.price = 0;  // 7 require
        this.producePlace = "";  // 8 optional
        this.ss_points = 0;  // 9 require
        this.valid = false;  // 10 require
        this.ss_type = "";  // 11 require
        this.sendPrice = 0;  // 12 require
        this.totalSendPrice = 0;  // 13 require
        this.totalPrice = 0;  // 14 require
        this.productionDate = "";  // 15 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderSku.__json_class__ = 'MisComm.OrderSku'

export class Order {
    constructor() {
        this.orderid = 0;  // 0 require
        this.buyer_userid = 0;  // 1 require
        this.buyer_companyid = 0;  // 2 require
        this.seller_companyid = 0;  // 3 require
        this.payMethod = "";  // 4 require
        this.payStatus = "";  // 5 require
        this.status = "";  // 6 require
        this.price = 0;  // 7 require
        this.note = "";  // 8 require
        this.weixin_prepay_id = "";  // 9 require
        this.arriveBeginTime = null;  // 10 require
        this.arriveEndTime = null;  // 11 require
        this.contactUUID = "";  // 12 require
        this.ss_contactName = "";  // 13 require
        this.ss_contactPhone = "";  // 14 require
        this.ss_contactMobile = "";  // 15 require
        this.ss_contactAddress = "";  // 16 require
        this.province = "";  // 17 require
        this.city = "";  // 18 require
        this.district = "";  // 19 require
        this.address = "";  // 20 require
        this.create_time = null;  // 21 require
        this.modify_time = null;  // 22 require
        this.afterSaleStatus = "";  // 23 require
        this.afterSaleReason = "";  // 24 require
        this.afterSaleResult = "";  // 25 require
        this.ss_price = 0;  // 26 require
        this.price = 0;  // 27 require
        this.buyer_shopid = 0;  // 28 require
        this.platformUserBalance = 0;  // 29 optional
        this.platformUserRiceCoin = 0;  // 30 optional
        this.platformCompanyBalance = 0;  // 31 optional
        this.platformCompanyRiceCoin = 0;  // 32 optional
        this.ecardPrice = 0;  // 33 optional
        this.payablePrice = 0;  // 34 require
        this.transferCode = "";  // 35 require
        this.type = "";  // 36 require
        this.deliveryStatus = "";  // 37 require
        this.deliveryUserid = 0;  // 38 require
        this.receivedTime = null;  // 39 require
        this.outStoreTime = null;  // 40 require
        this.agentUserid = 0;  // 41 require
        this.pointsExchange = 0;  // 42 require
        this.seller_note = "";  // 43 require
        this.orderCode = "";  // 44 require
        this.shareToken = "";  // 46 require
        this.collection = 0;  // 47 require
        this.chargeType = "";  // 48 require
        this.openDate = null;  // 49 require
        this.returnPrice = 0;  // 50 require
        this.unpaidPrice = 0;  // 51 require
        this.totalSendPrice = 0;  // 52 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Order.__json_class__ = 'MisComm.Order'

export class OrderInfo {
    constructor() {
        this.order = new Order();  // 0 require
        this.orderSkuList = [];  // 1 require
        this.seller_companyName = "";  // 2 require
        this.buyer_companyName = "";  // 3 require
        this.buyerName = "";  // 4 require
        this.buyer_shopName = "";  // 5 require
        this.saleUserName = "";  // 6 require
        this.deliveryUserName = "";  // 7 require
        this.agentUserName = "";  // 8 require
        this.deliveryMobile = "";  // 9 require
        this.signinUserName = "";  // 10 require
        this.customName = "";  // 11 require
        this.customContactName = "";  // 13 require
        this.customContactMobile = "";  // 14 require
        this.deliveryUserids = [];  // 15 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderInfo.__json_class__ = 'MisComm.OrderInfo'

export class OrderSimpleInfo {
    constructor() {
        this.orderid = 0;  // 0 require
        this.skuDesc = "";  // 1 require
        this.buyer_companyName = "";  // 2 require
        this.buyer_shopName = "";  // 3 require
        this.seller_companyName = "";  // 4 require
        this.price = 0;  // 5 require
        this.collection = 0;  // 6 require
        this.payMethod = "";  // 8 require
        this.payStatus = "";  // 9 require
        this.unpaidPrice = "";  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderSimpleInfo.__json_class__ = 'MisComm.OrderSimpleInfo'

export class BankAccount {
    constructor() {
        this.number = "";  // 0 require
        this.name = "";  // 1 require
        this.bankName = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BankAccount.__json_class__ = 'MisComm.BankAccount'

export class OrderPrintInfo {
    constructor() {
        this.makerName = "";  // 0 require
        this.storeName = "";  // 1 require
        this.account = new BankAccount();  // 2 require
        this.remark = "";  // 3 require
        this.isPaperBill = false;  // 4 require
        this.isHidePrice = false;  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderPrintInfo.__json_class__ = 'MisComm.OrderPrintInfo'

export class OrderDetail {
    constructor() {
        this.orderInfo = new OrderInfo();  // 0 require
        this.buyer_companyBasic = new CompanyBasic();  // 1 require
        this.seller_companyBasic = new CompanyBasic();  // 2 require
        this.orderPrintInfo = new OrderPrintInfo();  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderDetail.__json_class__ = 'MisComm.OrderDetail'

export class BatchOrder {
    constructor() {
        this.batchOrderid = 0;  // 0 require
        this.buyer_userid = 0;  // 1 require
        this.buyer_companyid = 0;  // 2 require
        this.buyer_shopid = 0;  // 3 require
        this.orderids = [];  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BatchOrder.__json_class__ = 'MisComm.BatchOrder'

export class BatchOrderInfo {
    constructor() {
        this.batchOrder = new BatchOrder();  // 0 require
        this.orderInfos = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

BatchOrderInfo.__json_class__ = 'MisComm.BatchOrderInfo'

export class ECard {
    constructor() {
        this.cardid = 0;  // 0 require
        this.title = "";  // 1 require
        this.buyer_userid = 0;  // 2 require
        this.buyer_customCompanyid = 0;  // 3 require
        this.seller_companyid = 0;  // 4 require
        this.cardType = "";  // 5 require
        this.isActive = false;  // 6 require
        this.activeDate = null;  // 7 require
        this.expireDate = null;  // 8 require
        this.value = 0;  // 9 require
        this.activeCode = "";  // 10 require
        this.cardDesc = "";  // 11 require
        this.usageRule = "";  // 12 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ECard.__json_class__ = 'MisComm.ECard'

export class SkuCount {
    constructor() {
        this.skuid = 0;  // 0 require
        this.count = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuCount.__json_class__ = 'MisComm.SkuCount'

export class CardCost {
    constructor() {
        this.cardid = 0;  // 0 require
        this.cost = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CardCost.__json_class__ = 'MisComm.CardCost'

export class SkuPrice {
    constructor() {
        this.skuid = 0;  // 0 require
        this.price = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuPrice.__json_class__ = 'MisComm.SkuPrice'

export class OrderIn {
    constructor() {
        this.payMethod = "";  // 0 require
        this.note = "";  // 1 require
        this.arriveBeginTime = null;  // 2 require
        this.arriveEndTime = null;  // 3 require
        this.contactUUID = "";  // 4 require
        this.skuCnts = [];  // 5 require
        this.platformCompanyCardCost = null;  // 6 optional
        this.platformUserCardCost = null;  // 7 optional
        this.ecardsCost = [];  // 8 optional
        this.customid = 0;  // 9 optional
        this.sellerCompanyCardCost = null;  // 10 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderIn.__json_class__ = 'MisComm.OrderIn'

export class OrderIdInfo {
    constructor() {
        this.skuCnts = [];  // 0 require
        this.seller_companyid = 0;  // 1 require
        this.contractid = 0;  // 2 optional
        this.seller_customid = 0;  // 3 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderIdInfo.__json_class__ = 'MisComm.OrderIdInfo'

export class OrderPriceInfo {
    constructor() {
        this.skuPrices = [];  // 0 require
        this.totalPrice = 0;  // 1 require
        this.payTypeBits = 0;  // 2 require
        this.nextBillPriceRatio = 0;  // 3 require
        this.platformCompanyCard = null;  // 4 optional
        this.platformUserCard = null;  // 4 optional
        this.ecards = [];  // 5 optional
        this.sellerCompanyCard = null;  // 6 optional
        this.defaultPayTypeBit = 0;  // 7 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderPriceInfo.__json_class__ = 'MisComm.OrderPriceInfo'

export class SaleRankItem {
    constructor() {
        this.saleUserid = 0;  // 0 require
        this.name = "";  // 1 require
        this.orderAmount = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SaleRankItem.__json_class__ = 'MisComm.SaleRankItem'

export class SaleRank {
    constructor() {
        this.items = [];  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SaleRank.__json_class__ = 'MisComm.SaleRank'

export class PercentItem {
    constructor() {
        this.label = "";  // 0 require
        this.percent = 0.0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PercentItem.__json_class__ = 'MisComm.PercentItem'

export class CustomConstruct {
    constructor() {
        this.percents = [];  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomConstruct.__json_class__ = 'MisComm.CustomConstruct'

export class OrderOverview {
    constructor() {
        this.orderCount7Days = 0;  // 0 require
        this.willPayCount = 0;  // 1 require
        this.willTransportCount = 0;  // 2 require
        this.afterSaleCount = 0;  // 3 require
        this.orderAmount7Days = 0;  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderOverview.__json_class__ = 'MisComm.OrderOverview'

export class AbnormalCustomBar {
    constructor() {
        this.date = null;  // 0 require
        this.payAmount = 0;  // 1 require
        this.payAmountGrowRate = 0;  // 2 require
        this.uPayCount = 0;  // 3 require
        this.uPayCountGrowRate = 0;  // 4 require
        this.orderAmount = 0;  // 5 require
        this.orderAmountGrowRate = 0;  // 6 require
        this.uOrderCount = 0;  // 7 require
        this.uOrderCountGrowRate = 0;  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AbnormalCustomBar.__json_class__ = 'MisComm.AbnormalCustomBar'

export class AbnormalCustomStat {
    constructor() {
        this.customName = "";  // 0 require
        this.bars = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AbnormalCustomStat.__json_class__ = 'MisComm.AbnormalCustomStat'

export class AbnormalCustomStatRecently {
    constructor() {
        this.customName = "";  // 0 require
        this.bar = new AbnormalCustomBar();  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AbnormalCustomStatRecently.__json_class__ = 'MisComm.AbnormalCustomStatRecently'

export class DeliveryInfo {
    constructor() {
        this.count = 0;  // 0 require
        this.lastTime = null;  // 1 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

DeliveryInfo.__json_class__ = 'MisComm.DeliveryInfo'
export var TAB_TYPE_CATEGORY = "category";
export var TAB_TYPE_GROUP = "group";
export var TAB_TYPE_MALLTAB = "malltab";
export var TAB_TYPE_CUSTOM = "custom";
export var TAB_TYPE_RESTOCK = "restock";
export var TAB_TYPE_CONTRACT = "contract";
export var TAB_TYPE_ORDER_RECENT = "order_recent";
export var TAB_TYPE_COMPLIMENTARY = "complimentary";

export class Category {
    constructor() {
        this.cateid = 0;  // 0 require
        this.parentid = 0;  // 1 require
        this.name = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Category.__json_class__ = 'MisComm.Category'

export class CategoryTreeItem {
    constructor() {
        this.category = new Category();  // 0 require
        this.children = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CategoryTreeItem.__json_class__ = 'MisComm.CategoryTreeItem'

export class MallSubTab {
    constructor() {
        this.tabid = 0;  // 0 require
        this.name = "";  // 2 require
        this.type = "";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

MallSubTab.__json_class__ = 'MisComm.MallSubTab'

export class MallTab {
    constructor() {
        this.tabid = 0;  // 0 require
        this.name = "";  // 2 require
        this.type = "";  // 3 require
        this.subTabs = [];  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

MallTab.__json_class__ = 'MisComm.MallTab'
export var SPU_TYPE_SELL = "sell";
export var SPU_TYPE_POINT = "point";
export var SPU_TYPE_COMPLIMENTARY = "complimentary";

export class SpuBasic {
    constructor() {
        this.spuid = 0;  // 0 require
        this.cateid = 0;  // 1 require
        this.name = "";  // 2 require
        this.producePlace = "";  // 4 require
        this.companyid = 0;  // 5 require
        this.brand = "";  // 6 require
        this.storeCondition = "";  // 7 require
        this.expirationDate = 0;  // 8 require
        this.userid = 0;  // 9 require
        this.type = "";  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SpuBasic.__json_class__ = 'MisComm.SpuBasic'

export class InvalidPrice {
    constructor() {
        this.type = "";  // 0 require
        this.price = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

InvalidPrice.__json_class__ = 'MisComm.InvalidPrice'

export class SkuBasic {
    constructor() {
        this.skuid = 0;  // 0 require
        this.cateid = 0;  // 1 require
        this.spuid = 0;  // 2 require
        this.price = 0;  // 3 require
        this.origPrice = 0;  // 4 require
        this.sellCount = 0;  // 5 require
        this.propDescs = [];  // 6 require
        this.imgs = [];  // 7 require
        this.canSellCount = 0;  // 8 require
        this.barcode = "";  // 9 optional
        this.type = "";  // 10 require
        this.storeCount = 0;  // 11 optional
        this.invalidPriceList = [];  // 12 require
        this.remainingTime = 0;  // 13 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuBasic.__json_class__ = 'MisComm.SkuBasic'

export class SpuInfo {
    constructor() {
        this.spuBasic = new SpuBasic();  // 0 require
        this.skuList = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SpuInfo.__json_class__ = 'MisComm.SpuInfo'

export class SpuDetail {
    constructor() {
        this.spuInfo = new SpuInfo();  // 0 require
        this.content = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SpuDetail.__json_class__ = 'MisComm.SpuDetail'

export class OrderRedPoint {
    constructor() {
        this.statusCountMap = {};  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderRedPoint.__json_class__ = 'MisComm.OrderRedPoint'
export var IMAGE_TYPE_IDCARD_FRONT = "idcard_front";
export var IMAGE_TYPE_IDCARD_BACK = "idcard_back";
export var IMAGE_TYPE_FACE_FRONT = "face_front";
export var IMAGE_TYPE_LEGAL_IDCARD_FRONT = "legal_idcard_front";
export var IMAGE_TYPE_LEGAL_IDCARD_BACK = "legal_idcard_back";
export var IMAGE_TYPE_LICENSE = "license";
export var IMAGE_TYPE_FOOD_BIZ_LICENSE = "food_biz_license";
export var IMAGE_TYPE_SKU = "sku";
export var IMAGE_TYPE_SKU_LIST = "sku_list";
export var FILE_TYPE_SKU_LIST = "sku_list_file";
export var FILE_TYPE_TRANSACTION = "transaction";
export var FILE_TYPE_OTHER = "other_file";

export class UploadIn {
    constructor() {
        this.base64Content = "";  // 0 require
        this.type = "";  // 1 require
        this.name = "";  // 2 require
        this.isSyncOss = true;  // 3 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

UploadIn.__json_class__ = 'MisComm.UploadIn'

export class UploadedData {
    constructor() {
        this.relPath = "";  // 0 require
        this.path = "";  // 1 require
        this.jsonData = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UploadedData.__json_class__ = 'MisComm.UploadedData'

export class CertifyUserIn {
    constructor() {
        this.idcard_front = "";  // 0 require
        this.idcard_back = "";  // 1 require
        this.face_front = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CertifyUserIn.__json_class__ = 'MisComm.CertifyUserIn'

export class CertifyCompanyIn {
    constructor() {
        this.license = "";  // 0 require
        this.idcard_front = "";  // 1 require
        this.idcard_back = "";  // 2 require
        this.food_biz_license = "";  // 3 optional
    }

    dump() {
        return JSON.stringify(this);
    }
}

CertifyCompanyIn.__json_class__ = 'MisComm.CertifyCompanyIn'
export var CERTIFY_STATUS_UNCERTIFIED = "uncertified";
export var CERTIFY_STATUS_CERTIFING = "certifing";
export var CERTIFY_STATUS_CERTIFIED = "certified";

export class CertifyData {
    constructor() {
        this.status = "";  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CertifyData.__json_class__ = 'MisComm.CertifyData'

export class UserCertifyInfo {
    constructor() {
        this.status = "";  // 0 require
        this.idCardFront = "";  // 1 require
        this.idCardBack = "";  // 2 require
        this.faceFront = "";  // 3 require
        this.username = "";  // 4 require
        this.idNumber = "";  // 5 require
        this.userRealName = "";  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

UserCertifyInfo.__json_class__ = 'MisComm.UserCertifyInfo'

export class CompanyCertifyInfo {
    constructor() {
        this.status = "";  // 0 require
        this.idCardFront = "";  // 1 require
        this.idCardBack = "";  // 2 require
        this.license = "";  // 3 require
        this.foodBizLicense = "";  // 4 require
        this.companyName = "";  // 5 require
        this.legalPersonName = "";  // 6 require
        this.legalPersonIdNumber = "";  // 7 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyCertifyInfo.__json_class__ = 'MisComm.CompanyCertifyInfo'
export var CUSTOM_TYPE_BUYER = "buyer";
export var CUSTOM_TYPE_SELLER = "seller";
export var CUSTOM_TYPE_LOGISTICS = "logistics";

export class CustomBasic {
    constructor() {
        this.customid = 0;  // 0 require
        this.name = "";  // 1 require
        this.contactName = "";  // 3 require
        this.contactMobile = "";  // 4 require
        this.fullAddress = "";  // 5 require
        this.targetType = "";  // 6 require
        this.orderCount = 0;  // 7 require
        this.lastOrderCreateTime = null;  // 8 require
        this.orderPeriod = 0;  // 9 require
        this.lastOrderid = 0;  // 10 require
        this.lastOrderUserid = 0;  // 11 require
        this.customCode = "";  // 12 require
        this.type = "";  // 13 require
        this.star = 0;  // 14 require
        this.source = "";  // 15 require
        this.saleUserid = 0;  // 16 require
        this.province = "";  // 17 require
        this.city = "";  // 18 require
        this.district = "";  // 19 require
        this.address = "";  // 20 require
        this.target_customCompanyid = 0;  // 21 require
        this.target_shopid = 0;  // 22 require
        this.targetCompanyType = "";  // 23 require
        this.cateid = 0;  // 25 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomBasic.__json_class__ = 'MisComm.CustomBasic'

export class CustomInfo {
    constructor() {
        this.custom = new CustomBasic();  // 0 require
        this.saleUserName = "";  // 1 require
        this.groups = [];  // 2 require
        this.target_customCompanyName = "";  // 3 require
        this.cateName = "";  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomInfo.__json_class__ = 'MisComm.CustomInfo'
export var AD_TYPE_MAIN_HEADER = "main_header";

export class AdInfo {
    constructor() {
        this.image = "";  // 0 require
        this.type = "";  // 1 require
        this.link = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

AdInfo.__json_class__ = 'MisComm.AdInfo'

export class CompanyIn {
    constructor() {
        this.name = "";  // 0 require
        this.province = "";  // 2 require
        this.city = "";  // 3 require
        this.district = "";  // 4 require
        this.address = "";  // 5 require
        this.type = "";  // 6 require
        this.legalPersonName = "";  // 7 require
        this.mobile = "";  // 8 require
        this.phone = "";  // 9 require
        this.desc = "";  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyIn.__json_class__ = 'MisComm.CompanyIn'

export class CustomCompanyIn {
    constructor() {
        this.name = "";  // 0 require
        this.province = "";  // 1 require
        this.city = "";  // 2 require
        this.district = "";  // 3 require
        this.address = "";  // 4 require
        this.type = "";  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomCompanyIn.__json_class__ = 'MisComm.CustomCompanyIn'

export class CustomGroup {
    constructor() {
        this.groupid = 0;  // 0 require
        this.companyid = 0;  // 1 require
        this.name = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomGroup.__json_class__ = 'MisComm.CustomGroup'

export class CustomCategory {
    constructor() {
        this.cateid = 0;  // 0 require
        this.companyid = 0;  // 1 require
        this.name = "";  // 2 require
        this.type = "";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomCategory.__json_class__ = 'MisComm.CustomCategory'

export class PriceSheetBasic {
    constructor() {
        this.sheetid = 0;  // 0 require
        this.groupid = 0;  // 1 require
        this.userid = 0;  // 2 require
        this.create_time = null;  // 3 require
        this.name = "";  // 4 require
        this.companyid = 0;  // 5 require
        this.target_customCompanyid = 0;  // 6 require
        this.type = "";  // 7 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceSheetBasic.__json_class__ = 'MisComm.PriceSheetBasic'

export class PriceSheetSkuIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.ss_name = "";  // 1 require
        this.ss_spec = "";  // 2 require
        this.ss_img = "";  // 3 require
        this.ss_price = 0;  // 4 require
        this.orig_price = 0;  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceSheetSkuIn.__json_class__ = 'MisComm.PriceSheetSkuIn'

export class PriceSheetSku {
    constructor() {
        this.skuid = 0;  // 0 require
        this.ss_name = "";  // 1 require
        this.ss_spec = "";  // 2 require
        this.ss_img = "";  // 3 require
        this.ss_price = 0;  // 4 require
        this.sheetid = 0;  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceSheetSku.__json_class__ = 'MisComm.PriceSheetSku'

export class PriceSheetInfo {
    constructor() {
        this.priceSheet = new PriceSheetBasic();  // 0 require
        this.skuList = [];  // 1 require
        this.group = null;  // 2 optional
        this.custom = null;  // 3 optional
        this.userName = "";  // 4 require
        this.mobile = "";  // 5 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceSheetInfo.__json_class__ = 'MisComm.PriceSheetInfo'

export class PriceSheetIn {
    constructor() {
        this.sheetid = 0;  // 0 require
        this.groupid = 0;  // 1 require
        this.customid = 0;  // 2 require
        this.name = "";  // 3 require
        this.skuList = [];  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceSheetIn.__json_class__ = 'MisComm.PriceSheetIn'

export class PriceSheetDetail {
    constructor() {
        this.info = new PriceSheetInfo();  // 0 require
        this.companyName = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PriceSheetDetail.__json_class__ = 'MisComm.PriceSheetDetail'
export var SKU_CREATE_TYPE_MANUAL = "manual";
export var SKU_CREATE_TYPE_MALL_IMPORT = "mall_import";
export var SKU_CREATE_TYPE_3RD_IMPORT = "third_party_import";

export class SkuIn {
    constructor() {
        this.skuid = 0;  // 0 require
        this.name = "";  // 1 require
        this.cateid = 0;  // 2 require
        this.prop0_name = "规格";  // 3 require
        this.prop0_value = "";  // 4 require
        this.buyPrice = 0;  // 5 require
        this.imgs = [];  // 6 require
        this.content = "";  // 7 require
        this.customid = 0;  // 8 require
        this.barcode = "";  // 9 require
        this.salePrice = 0;  // 10 require
        this.canSell = false;  // 11 require
        this.createType = "manual";  // 12 require
        this.refCode = "";  // 13 require
        this.type = "sell";  // 14 require
        this.weight = 0.0;  // 15 require
        this.unitName = "";  // 16 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuIn.__json_class__ = 'MisComm.SkuIn'
export var APPLICATION_STATUS_WAITTING = "waitting";
export var APPLICATION_STATUS_APPROVED = "approved";
export var APPLICATION_STATUS_REJECTED = "rejected";
export var APPLICATION_STATUS_CANCELED = "canceled";
export var APPROVAL_STATUS_UNKNOWN = "unknown";
export var APPROVAL_STATUS_APPROVED = "approved";
export var APPROVAL_STATUS_REJECTED = "rejected";

export class ApprovalIn {
    constructor() {
        this.taskid = 0;  // 0 require
        this.status = "";  // 1 require
        this.comment = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ApprovalIn.__json_class__ = 'MisComm.ApprovalIn'

export class SpuDetailInfoIn {
    constructor() {
        this.spuid = 0;  // 0 require
        this.goodsName = "";  // 1 require
        this.goodsDesc = "";  // 2 require
        this.infoimgs = [];  // 3 require
        this.attributeImgs = [];  // 4 require
        this.packingImgs = [];  // 5 require
        this.quality = "";  // 6 require
        this.companyDesc = "";  // 7 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SpuDetailInfoIn.__json_class__ = 'MisComm.SpuDetailInfoIn'

export class SearchSpuIn {
    constructor() {
        this.text = "";  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SearchSpuIn.__json_class__ = 'MisComm.SearchSpuIn'
export var SCOPE_ALL = "all";
export var SCOPE_PLATFORM = "platform";
export var SCOPE_COMPANY = "company";

export class SearchCompanyIn {
    constructor() {
        this.keyword = "";  // 0 require
        this.type = "";  // 1 require
        this.scope = "all";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SearchCompanyIn.__json_class__ = 'MisComm.SearchCompanyIn'

export class SearchShopIn {
    constructor() {
        this.keyword = "";  // 0 require
        this.certifyStatus = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SearchShopIn.__json_class__ = 'MisComm.SearchShopIn'

export class ApplyJoinCompanyIn {
    constructor() {
        this.companyid = 0;  // 0 require
        this.shopids = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ApplyJoinCompanyIn.__json_class__ = 'MisComm.ApplyJoinCompanyIn'

export class ApplyCustomIn {
    constructor() {
        this.sellerCompanyid = 0;  // 0 require
        this.shopid = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ApplyCustomIn.__json_class__ = 'MisComm.ApplyCustomIn'

export class ApprovalUser {
    constructor() {
        this.nickname = "";  // 0 require
        this.mobile = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ApprovalUser.__json_class__ = 'MisComm.ApprovalUser'

export class ApplicationInfo {
    constructor() {
        this.taskid = 0;  // 0 require
        this.title = "";  // 1 require
        this.content = "";  // 2 require
        this.chargeUserid = 0;  // 3 require
        this.type = "";  // 4 require
        this.status = "";  // 5 require
        this.jsonContent = "";  // 6 require
        this.approvers = [];  // 7 require
        this.create_time = null;  // 8 require
        this.nextApprovers = [];  // 9 require
        this.createUser = new ApprovalUser();  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ApplicationInfo.__json_class__ = 'MisComm.ApplicationInfo'

export class ShopIn {
    constructor() {
        this.companyid = 0;  // 0 require
        this.name = "";  // 1 require
        this.province = "";  // 3 require
        this.city = "";  // 4 require
        this.district = "";  // 5 require
        this.address = "";  // 6 require
        this.mobile = "";  // 7 require
        this.contactName = "";  // 8 require
        this.shopid = 0;  // 9 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ShopIn.__json_class__ = 'MisComm.ShopIn'

export class CompanyShopInfo {
    constructor() {
        this.companyid = 0;  // 0 require
        this.companyName = "";  // 1 require
        this.companyType = "";  // 2 require
        this.shopids = [];  // 3 require
        this.shopNames = [];  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyShopInfo.__json_class__ = 'MisComm.CompanyShopInfo'

export class CustomIn {
    constructor() {
        this.type = "";  // 0 require
        this.star = 0;  // 1 require
        this.contactMobile = "";  // 2 require
        this.contactName = "";  // 3 require
        this.target_customCompanyid = 0;  // 4 require
        this.saleUserid = 0;  // 5 require
        this.name = "";  // 6 require
        this.province = "";  // 7 require
        this.city = "";  // 8 require
        this.district = "";  // 9 require
        this.address = "";  // 10 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomIn.__json_class__ = 'MisComm.CustomIn'

export class ShopUserInfo {
    constructor() {
        this.userid = 0;  // 0 require
        this.nickname = "";  // 1 require
        this.mobile = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ShopUserInfo.__json_class__ = 'MisComm.ShopUserInfo'

export class SearchCustomIn {
    constructor() {
        this.keyword = "";  // 0 require
        this.activeType = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SearchCustomIn.__json_class__ = 'MisComm.SearchCustomIn'

export class CompanyName {
    constructor() {
        this.companyid = 0;  // 0 require
        this.name = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyName.__json_class__ = 'MisComm.CompanyName'

export class CustomCompany {
    constructor() {
        this.customCompanyid = 0;  // 0 require
        this.name = "";  // 1 require
        this.type = "";  // 2 require
        this.province = "";  // 3 require
        this.city = "";  // 4 require
        this.district = "";  // 5 require
        this.address = "";  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CustomCompany.__json_class__ = 'MisComm.CustomCompany'

export class Contract {
    constructor() {
        this.contractid = 0;  // 0 require
        this.buyer_customCompanyid = 0;  // 1 require
        this.seller_companyid = 0;  // 2 require
        this.name = "";  // 3 require
        this.canAccountCredit = false;  // 4 require
        this.canFaceCash = false;  // 5 require
        this.moq = 0;  // 6 require
        this.moqWeight = 0;  // 7 require
        this.beginTime = null;  // 8 require
        this.endTime = null;  // 9 require
        this.buyer_signTime = null;  // 10 require
        this.seller_signTime = null;  // 11 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Contract.__json_class__ = 'MisComm.Contract'

export class PayOrderImagesIn {
    constructor() {
        this.orderid = 0;  // 0 require
        this.images = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PayOrderImagesIn.__json_class__ = 'MisComm.PayOrderImagesIn'

export class Perm {
    constructor() {
        this.name = "";  // 0 require
        this.desc = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

Perm.__json_class__ = 'MisComm.Perm'

export class PermCate {
    constructor() {
        this.title = "";  // 0 require
        this.perms = [];  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PermCate.__json_class__ = 'MisComm.PermCate'

export class SearchOrderIn {
    constructor() {
        this.customid = 0;  // 0 require
        this.status = "";  // 1 require
        this.keyword = "";  // 2 require
        this.chargeType = "seller";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SearchOrderIn.__json_class__ = 'MisComm.SearchOrderIn'

export class JoinCustomCompanyIn {
    constructor() {
        this.customCompanyid = 0;  // 0 require
        this.customid = 0;  // 1 require
        this.customName = "";  // 2 require
        this.contactName = "";  // 3 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

JoinCustomCompanyIn.__json_class__ = 'MisComm.JoinCustomCompanyIn'

export class ReturnOrderSku {
    constructor() {
        this.skuid = 0;  // 0 require
        this.ss_name = "";  // 1 require
        this.ss_spec = "";  // 2 require
        this.ss_price = 0;  // 3 require
        this.count = 0;  // 4 require
        this.price = 0;  // 5 require
        this.ss_averageCost = 0;  // 6 require
        this.totalPrice = 0;  // 7 require
        this.producePlace = "";  // 8 require
        this.price = 0;  // 9 require
        this.sendPrice = 0;  // 10 require
        this.totalSendPrice = 0;  // 11 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ReturnOrderSku.__json_class__ = 'MisComm.ReturnOrderSku'

export class ReturnOrderBasic {
    constructor() {
        this.orderid = 0;  // 0 require
        this.returnid = 0;  // 1 require
        this.openDate = null;  // 2 require
        this.note = "";  // 3 require
        this.price = 0;  // 4 require
        this.status = "";  // 5 require
        this.finChecked = false;  // 6 require
        this.finCheckedNote = "";  // 7 require
        this.finCheckedTime = null;  // 8 require
        this.finCheckedUserid = "";  // 9 require
        this.finCheckedType = "";  // 10 require
        this.type = "";  // 11 require
        this.create_time = null;  // 12 require
        this.totalSendPrice = 0;  // 13 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ReturnOrderBasic.__json_class__ = 'MisComm.ReturnOrderBasic'

export class ReturnOrderDetail {
    constructor() {
        this.printInfo = new OrderPrintInfo();  // 0 require
        this.returnOrderSkuList = [];  // 1 require
        this.companyInfo = new CompanyBasic();  // 2 require
        this.customInfo = new CustomBasic();  // 4 require
        this.returnOrderBasic = new ReturnOrderBasic();  // 6 require
        this.saleUserName = "";  // 7 require
        this.deliveryUserNames = [];  // 8 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

ReturnOrderDetail.__json_class__ = 'MisComm.ReturnOrderDetail'

export class SkuInfo {
    constructor() {
        this.skuid = 0;  // 0 require
        this.count = 0;  // 1 require
        this.ss_name = "";  // 2 require
        this.ss_spec = "";  // 3 require
        this.unitName = "";  // 4 require
        this.ss_type = "";  // 5 require
        this.buyPrice = 0;  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

SkuInfo.__json_class__ = 'MisComm.SkuInfo'

export class OrderIdSku {
    constructor() {
        this.orderid = 0;  // 0 require
        this.totalCount = 0;  // 1 require
        this.totalCost = 0;  // 2 require
        this.totalPrice = 0;  // 3 require
        this.skuList = [];  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OrderIdSku.__json_class__ = 'MisComm.OrderIdSku'

export class MisCommInterfApi extends BaseInterfApi {
    constructor(baseUrl, moduleName='MisComm',
            interfName='MisCommInterf', token='anonymous', ...args) {
        super(baseUrl, moduleName, interfName, token, ...args)
    }


    queryAddressCode(query, context) {
        let params = {
            query: query,
            };
        let req = this.createRequest('queryAddressCode', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('queryAddressCode'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSellerCompanyConfig(companyid, context) {
        let params = {
            companyid: companyid,
            };
        let req = this.createRequest('getSellerCompanyConfig', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSellerCompanyConfig'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPlatformUserCard( context) {
        let params = {
            };
        let req = this.createRequest('getPlatformUserCard', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPlatformUserCard'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPlatformCompanyCard( context) {
        let params = {
            };
        let req = this.createRequest('getPlatformCompanyCard', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPlatformCompanyCard'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getDepositConfig( context) {
        let params = {
            };
        let req = this.createRequest('getDepositConfig', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getDepositConfig'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getWxDepositPayInfo(info,openid, context) {
        let params = {
            info: info,
            openid: openid,
            };
        let req = this.createRequest('getWxDepositPayInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getWxDepositPayInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAlipayDepositPayInfo(info, context) {
        let params = {
            info: info,
            };
        let req = this.createRequest('getAlipayDepositPayInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAlipayDepositPayInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUnionpayDepositPayInfo(info,successUrl, context) {
        let params = {
            info: info,
            successUrl: successUrl,
            };
        let req = this.createRequest('getUnionpayDepositPayInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUnionpayDepositPayInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getTransferDepositPayInfo(info, context) {
        let params = {
            info: info,
            };
        let req = this.createRequest('getTransferDepositPayInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getTransferDepositPayInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getDepositRecord(depositid, context) {
        let params = {
            depositid: depositid,
            };
        let req = this.createRequest('getDepositRecord', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getDepositRecord'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUnionpayPayInfo(payInfoIn, context) {
        let params = {
            payInfoIn: payInfoIn,
            };
        let req = this.createRequest('getUnionpayPayInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUnionpayPayInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getWechatPayInfo(payInfoIn,openid, context) {
        let params = {
            payInfoIn: payInfoIn,
            openid: openid,
            };
        let req = this.createRequest('getWechatPayInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getWechatPayInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAlipayPayInfo(payInfoIn, context) {
        let params = {
            payInfoIn: payInfoIn,
            };
        let req = this.createRequest('getAlipayPayInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAlipayPayInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    queryPayStatus(outTradeid, context) {
        let params = {
            outTradeid: outTradeid,
            };
        let req = this.createRequest('queryPayStatus', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('queryPayStatus'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyListByUserid(userid, context) {
        let params = {
            userid: userid,
            };
        let req = this.createRequest('getCompanyListByUserid', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyListByUserid'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShopListByUserid(userid, context) {
        let params = {
            userid: userid,
            };
        let req = this.createRequest('getShopListByUserid', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShopListByUserid'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyShops( context) {
        let params = {
            };
        let req = this.createRequest('getCompanyShops', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyShops'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyStores( context) {
        let params = {
            };
        let req = this.createRequest('getCompanyStores', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyStores'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompany(companyid, context) {
        let params = {
            companyid: companyid,
            };
        let req = this.createRequest('getCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShop(shopid, context) {
        let params = {
            shopid: shopid,
            };
        let req = this.createRequest('getShop', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShop'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyList(companyids, context) {
        let params = {
            companyids: companyids,
            };
        let req = this.createRequest('getCompanyList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShopList(shopids, context) {
        let params = {
            shopids: shopids,
            };
        let req = this.createRequest('getShopList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShopList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchCompany(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyShopList(companyid,pageIn, context) {
        let params = {
            companyid: companyid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getCompanyShopList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyShopList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchCompanyShop(companyid,seachIn,pageIn, context) {
        let params = {
            companyid: companyid,
            seachIn: seachIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchCompanyShop', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchCompanyShop'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createAndBindCompany(companyIn, context) {
        let params = {
            companyIn: companyIn,
            };
        let req = this.createRequest('createAndBindCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createAndBindCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrCreateDefaultCompany(mobile, context) {
        let params = {
            mobile: mobile,
            };
        let req = this.createRequest('getOrCreateDefaultCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrCreateDefaultCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateDefaultCompany(companyIn, context) {
        let params = {
            companyIn: companyIn,
            };
        let req = this.createRequest('updateDefaultCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateDefaultCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    applyJoinCompanyAndShop(joinIn, context) {
        let params = {
            joinIn: joinIn,
            };
        let req = this.createRequest('applyJoinCompanyAndShop', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('applyJoinCompanyAndShop'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getJoinCompanyApplication( context) {
        let params = {
            };
        let req = this.createRequest('getJoinCompanyApplication', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getJoinCompanyApplication'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    applyCustom(customIn, context) {
        let params = {
            customIn: customIn,
            };
        let req = this.createRequest('applyCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('applyCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateOrCreateCustomShop(shopIn, context) {
        let params = {
            shopIn: shopIn,
            };
        let req = this.createRequest('updateOrCreateCustomShop', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateOrCreateCustomShop'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    checkCompanyShopInfo(companyid,shopid,mobile, context) {
        let params = {
            companyid: companyid,
            shopid: shopid,
            mobile: mobile,
            };
        let req = this.createRequest('checkCompanyShopInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('checkCompanyShopInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyShopInfo(mobile, context) {
        let params = {
            mobile: mobile,
            };
        let req = this.createRequest('getCompanyShopInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyShopInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    checkShopUserMobile(shopid,mobile, context) {
        let params = {
            shopid: shopid,
            mobile: mobile,
            };
        let req = this.createRequest('checkShopUserMobile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('checkShopUserMobile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createCustom(customIn, context) {
        let params = {
            customIn: customIn,
            };
        let req = this.createRequest('createCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShopUsers(shopid, context) {
        let params = {
            shopid: shopid,
            };
        let req = this.createRequest('getShopUsers', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShopUsers'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchCustom(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSaleUsers( context) {
        let params = {
            };
        let req = this.createRequest('getSaleUsers', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSaleUsers'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createCustomCompany(companyIn, context) {
        let params = {
            companyIn: companyIn,
            };
        let req = this.createRequest('createCustomCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createCustomCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomCompanyList( context) {
        let params = {
            };
        let req = this.createRequest('getCustomCompanyList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomCompanyList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomCompanyPageList(pageIn, context) {
        let params = {
            pageIn: pageIn,
            };
        let req = this.createRequest('getCustomCompanyPageList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomCompanyPageList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomListByCompanyid(target_customCompanyid,pageIn, context) {
        let params = {
            target_customCompanyid: target_customCompanyid,
            pageIn: pageIn,
            };
        let req = this.createRequest('getCustomListByCompanyid', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomListByCompanyid'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    searchCustomCompany(searchIn,pageIn, context) {
        let params = {
            searchIn: searchIn,
            pageIn: pageIn,
            };
        let req = this.createRequest('searchCustomCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('searchCustomCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    joinCustomCompany(joinIn, context) {
        let params = {
            joinIn: joinIn,
            };
        let req = this.createRequest('joinCustomCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('joinCustomCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    mergeCustom(fromCustomid,toCustomid, context) {
        let params = {
            fromCustomid: fromCustomid,
            toCustomid: toCustomid,
            };
        let req = this.createRequest('mergeCustom', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('mergeCustom'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomCategoryList(type, context) {
        let params = {
            type: type,
            };
        let req = this.createRequest('getCustomCategoryList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomCategoryList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderInfoList(status,pageIn, context) {
        let params = {
            status: status,
            pageIn: pageIn,
            };
        let req = this.createRequest('getOrderInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAfterSaleOrderInfoList(afterSaleStatus,pageIn, context) {
        let params = {
            afterSaleStatus: afterSaleStatus,
            pageIn: pageIn,
            };
        let req = this.createRequest('getAfterSaleOrderInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAfterSaleOrderInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderInfo(orderid, context) {
        let params = {
            orderid: orderid,
            };
        let req = this.createRequest('getOrderInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderDetail(orderid, context) {
        let params = {
            orderid: orderid,
            };
        let req = this.createRequest('getOrderDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderDetailList(orderids, context) {
        let params = {
            orderids: orderids,
            };
        let req = this.createRequest('getOrderDetailList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderDetailList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getBatchOrderInfo(batchOrderid, context) {
        let params = {
            batchOrderid: batchOrderid,
            };
        let req = this.createRequest('getBatchOrderInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getBatchOrderInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getShareOrderDetail(orderid,shareToken, context) {
        let params = {
            orderid: orderid,
            shareToken: shareToken,
            };
        let req = this.createRequest('getShareOrderDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getShareOrderDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderSimpleInfo(orderid, context) {
        let params = {
            orderid: orderid,
            };
        let req = this.createRequest('getOrderSimpleInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderSimpleInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSaleOrderStat(saleUserid,period,pageIn, context) {
        let params = {
            saleUserid: saleUserid,
            period: period,
            pageIn: pageIn,
            };
        let req = this.createRequest('getSaleOrderStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSaleOrderStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSellerOrderStat(period,pageIn, context) {
        let params = {
            period: period,
            pageIn: pageIn,
            };
        let req = this.createRequest('getSellerOrderStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSellerOrderStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSaleRank(date,period, context) {
        let params = {
            date: date,
            period: period,
            };
        let req = this.createRequest('getSaleRank', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSaleRank'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCustomConstruct(tablename,date, context) {
        let params = {
            tablename: tablename,
            date: date,
            };
        let req = this.createRequest('getCustomConstruct', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCustomConstruct'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderOverview( context) {
        let params = {
            };
        let req = this.createRequest('getOrderOverview', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderOverview'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAbnormalCustomStat(saleUserid,period,orderByField,limit, context) {
        let params = {
            saleUserid: saleUserid,
            period: period,
            orderByField: orderByField,
            limit: limit,
            };
        let req = this.createRequest('getAbnormalCustomStat', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAbnormalCustomStat'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAbnormalCustomStatRecently(saleUserid,period,orderByField,pageIn, context) {
        let params = {
            saleUserid: saleUserid,
            period: period,
            orderByField: orderByField,
            pageIn: pageIn,
            };
        let req = this.createRequest('getAbnormalCustomStatRecently', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAbnormalCustomStatRecently'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getDeliveryInfo(userid, context) {
        let params = {
            userid: userid,
            };
        let req = this.createRequest('getDeliveryInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getDeliveryInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCategoryList( context) {
        let params = {
            };
        let req = this.createRequest('getCategoryList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCategoryList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCategory0List( context) {
        let params = {
            };
        let req = this.createRequest('getCategory0List', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCategory0List'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCategory1List( context) {
        let params = {
            };
        let req = this.createRequest('getCategory1List', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCategory1List'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCategorySubList(parentid, context) {
        let params = {
            parentid: parentid,
            };
        let req = this.createRequest('getCategorySubList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCategorySubList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCategoryTree( context) {
        let params = {
            };
        let req = this.createRequest('getCategoryTree', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCategoryTree'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUnits( context) {
        let params = {
            };
        let req = this.createRequest('getUnits', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUnits'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getSellerMallTabList(companyid, context) {
        let params = {
            companyid: companyid,
            };
        let req = this.createRequest('getSellerMallTabList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getSellerMallTabList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUsersByRole(role, context) {
        let params = {
            role: role,
            };
        let req = this.createRequest('getUsersByRole', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUsersByRole'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    uploadFile(uploadIn, context) {
        let params = {
            uploadIn: uploadIn,
            };
        let req = this.createRequest('uploadFile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('uploadFile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    certifyUser(certifyIn, context) {
        let params = {
            certifyIn: certifyIn,
            };
        let req = this.createRequest('certifyUser', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('certifyUser'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    certifyCompany(certifyIn, context) {
        let params = {
            certifyIn: certifyIn,
            };
        let req = this.createRequest('certifyCompany', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('certifyCompany'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getUserCertifyInfo( context) {
        let params = {
            };
        let req = this.createRequest('getUserCertifyInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getUserCertifyInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getCompanyCertifyInfo( context) {
        let params = {
            };
        let req = this.createRequest('getCompanyCertifyInfo', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getCompanyCertifyInfo'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    cancelUserCertify( context) {
        let params = {
            };
        let req = this.createRequest('cancelUserCertify', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('cancelUserCertify'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    cancelCompanyCertify( context) {
        let params = {
            };
        let req = this.createRequest('cancelCompanyCertify', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('cancelCompanyCertify'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getAdInfos(type, context) {
        let params = {
            type: type,
            };
        let req = this.createRequest('getAdInfos', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getAdInfos'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    cancelApplication(taskid, context) {
        let params = {
            taskid: taskid,
            };
        let req = this.createRequest('cancelApplication', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('cancelApplication'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    approvalApplication(approvalIn, context) {
        let params = {
            approvalIn: approvalIn,
            };
        let req = this.createRequest('approvalApplication', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('approvalApplication'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getApplication(taskid, context) {
        let params = {
            taskid: taskid,
            };
        let req = this.createRequest('getApplication', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getApplication'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    updateSpuDetail(spuDetailInfoIn, context) {
        let params = {
            spuDetailInfoIn: spuDetailInfoIn,
            };
        let req = this.createRequest('updateSpuDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('updateSpuDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    createBuyPaymentApplication(orderid,customBankAccountid, context) {
        let params = {
            orderid: orderid,
            customBankAccountid: customBankAccountid,
            };
        let req = this.createRequest('createBuyPaymentApplication', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('createBuyPaymentApplication'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    addPayOrderImages(imagesIn, context) {
        let params = {
            imagesIn: imagesIn,
            };
        let req = this.createRequest('addPayOrderImages', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('addPayOrderImages'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPayOrderImages(orderid, context) {
        let params = {
            orderid: orderid,
            };
        let req = this.createRequest('getPayOrderImages', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPayOrderImages'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    deletePayOrderImages(imagesIn, context) {
        let params = {
            imagesIn: imagesIn,
            };
        let req = this.createRequest('deletePayOrderImages', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('deletePayOrderImages'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    accountCheckByFile(companyid,bankType,filePath, context) {
        let params = {
            companyid: companyid,
            bankType: bankType,
            filePath: filePath,
            };
        let req = this.createRequest('accountCheckByFile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('accountCheckByFile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getNicknameByMobile(mobile, context) {
        let params = {
            mobile: mobile,
            };
        let req = this.createRequest('getNicknameByMobile', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getNicknameByMobile'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPermissionsByUserid(userid, context) {
        let params = {
            userid: userid,
            };
        let req = this.createRequest('getPermissionsByUserid', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPermissionsByUserid'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    setPermissionsByUserid(userid,permissions, context) {
        let params = {
            userid: userid,
            permissions: permissions,
            };
        let req = this.createRequest('setPermissionsByUserid', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('setPermissionsByUserid'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getPermCates(cateType, context) {
        let params = {
            cateType: cateType,
            };
        let req = this.createRequest('getPermCates', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getPermCates'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getReturnOrderDetail(returnOrderId, context) {
        let params = {
            returnOrderId: returnOrderId,
            };
        let req = this.createRequest('getReturnOrderDetail', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getReturnOrderDetail'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getOrderSkus(orderIds, context) {
        let params = {
            orderIds: orderIds,
            };
        let req = this.createRequest('getOrderSkus', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOrderSkus'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/apis/rpc/MisComm/MisComm.js